import styled from "styled-components";

export const SearchTermWrapper = styled.div`
    display: flex;
    align-items: center;

    border-radius: 20px;
    padding: 0px 10px;
    background-color: #F3F5F5;
    color: ${window?.settings?.secondary_color ?? '#04333b'};
    font-size: 12px;
    line-height: 24px;
    user-select: none;

    &:hover {
      font-weight: 600;
    }
`;